import { StoreState } from '../store-interfaces';
import { GoogleAccount } from '../interfaces/googleSheet';

export const hasGoogleSheetAccess = (account: GoogleAccount) => {
  return account.scope?.find(scope =>
    scope.includes('https://www.googleapis.com/auth/spreadsheets'),
  );
};

export const isOwnedByUser = (account: GoogleAccount) => {
  return !account.readOnly;
};

export const selectGoogleAccounts = (state: StoreState) =>
  state.googleSheets.accounts;

export const selectGoogleAccountsId = (state: StoreState) =>
  state.googleSheets.accountsId;

export const selectUserGoogleAccountsWithSheetSupport = (state: StoreState) =>
  state.googleSheets.accounts
    .filter(hasGoogleSheetAccess)
    .filter(isOwnedByUser);

export const selectSpreadsheets = (state: StoreState) =>
  state.googleSheets.spreadsheetsById?.spreadsheets ?? [];

export const selectSheets = (state: StoreState) => {
  const sheets = state.googleSheets.sheetsById?.sheets ?? [];
  return sheets.map(sheet => {
    return {
      id: sheet.sheetId,
      title: sheet.title,
    };
  });
};

export const selectSheetColumns = (state: StoreState) => {
  const sheets = state.googleSheets.columns?.columns ?? [];
  return sheets.map(sheet => {
    return {
      id: sheet,
      name: sheet,
    };
  });
};
